export default "__VITE_ASSET__DeIgEQnJ__"